/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { Data } from '../../../types.tsx';
import type { Props } from '../types.tsx';
import { fetchData } from './fetch-data/index.tsx';

const getData = async ({ preferenceKey }: Props): Promise<Data> => {
	try {
		const result = await fetchData(preferenceKey);
		return {
			value: result,
		};
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		if (e.statusCode === 404) {
			return { value: undefined };
		}
		throw e;
	}
};

export default getData;
